module.exports = __webpack_public_path__ + "static/46_optimized-5c9e14c223982b469bfbcf1b69e64fd8.jpg";